<script setup lang="ts">

import {Tooltip, TooltipContent, TooltipProvider, TooltipTrigger} from "@/core/components/ui/tooltip";

defineProps<{
    avoidCollisions?: boolean
    side?: 'top' | 'right' | 'bottom' | 'left'
}>();
</script>

<template>
  <TooltipProvider>
    <Tooltip>
      <TooltipTrigger as-child>
        <slot />
      </TooltipTrigger>
      <TooltipContent class="bg-primary font-medium text-base" :avoid-collisions="avoidCollisions" :side="side">
        <slot name="content" />
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
</template>

<style scoped>

</style>
